import type { MessageKey } from './generated/messages';

/**
 * The §21.5 envelope's error codes as catalog keys. Server messages are written in English only,
 * so a translated UI shows the localized text for the code instead of the server's words.
 */
const CODES = [
  'VALIDATION_ERROR',
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'PLAN_LIMIT_REACHED',
  'RATE_LIMITED',
  'IDEMPOTENCY_MISMATCH',
  'PAIRING_CODE_INVALID',
  'GATEWAY_UNAVAILABLE',
  'SERVICE_UNAVAILABLE',
  'STEP_UP_REQUIRED',
] as const;
const KNOWN = new Set<string>(CODES);

export type KnownErrorCode = (typeof CODES)[number];
export type ErrorMessageKey = `error.code.${KnownErrorCode}` | 'error.network' | 'error.generic';

/** The catalog key for an error code; anything unknown (INTERNAL_ERROR included) is generic. */
export function errorMessageKey(code: string | null | undefined): ErrorMessageKey & MessageKey {
  if (code === 'NETWORK') return 'error.network';
  return code && KNOWN.has(code) ? `error.code.${code as KnownErrorCode}` : 'error.generic';
}
